import { extendObject } from '@/assets/js/utils'

export const publicPage = {
  total: 0,
  currentPage: 1,
  pageSize: 20,
  pageSizes: [10, 20, 30, 50, 100],
  background: true
}
